import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-resend-verification',
  templateUrl: './resend-verification.component.html',
  styleUrls: ['./resend-verification.component.css']
})
export class ResendVerificationComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  onSendVerification(form: NgForm) {
    let mobile = `+94${form.value.mobile}`;

    this.authService.resendVerification(mobile);
  }
}
